import {
  Layout,
  Radio,
  Select,
  Space,
  SpaceProps,
  Switch,
  Tour,
  TourProps,
} from 'antd';
import React, { memo, useRef, useState } from 'react';
import { ProfileButton, Button, SelectBox } from 'components/src';
import { COLORS, i18n, useLanguage, useThemes } from 'core';
import { createUseStyles } from 'react-jss';
//@ts-ignore
import Logo1 from 'assets/src/img/messengerLogo1.png';
//@ts-ignore
import Logo2 from 'assets/src/img/messengerLogo2.png';
import { RadioChangeEvent } from 'antd/lib';

const useStyle = createUseStyles<string, unknown, COLORS>(
  (colors) => ({
    root: {
      padding: '4px',
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: `0.5px solid ${colors.theme01}`,
      width: '100%',
    },
    mobileLogo: {
      '@media (max-width: 768px)': {
        display: 'none',
      },
      display: 'inline',
    },
  })
);

interface props extends SpaceProps {
  children?: React.ReactNode;
  languageSwitch?: boolean;
  themeSwitch?: boolean;
  tourBtn?: boolean;
  profileBtn?: boolean;
  tourHandler?: () => void;
  profileHandler?: () => void;
  changePasswordHandler?: () => void;
  hamburgerMenu: React.ReactNode;
}
const { Header } = Layout;
const MyHeader = memo<props>(
  ({
    children,
    languageSwitch,
    themeSwitch,
    tourBtn,
    profileBtn,
    tourHandler,
    profileHandler,
    changePasswordHandler,
    hamburgerMenu,
  }) => {
    const classes = useStyle();
    const { isLight, changeTheme,changeTemplate,colors ,template} = useThemes();
    const { isPersian, changeLanguage } = useLanguage();
    const [open, setOpen] = useState<boolean>(false);

    const ref1 = useRef<HTMLButtonElement>(null);
    const ref2 = useRef<HTMLButtonElement>(null);
    const steps: TourProps['steps'] = [
      {
        title: i18n.t('ChangeTheme'),
        description: i18n.t('ChangeTheme'),
        target: () => ref1.current!,
      },
      {
        title: i18n.t('changeLanguage'),
        description: i18n.t('changeLanguage'),
        target: () => ref2.current!,
      },
    ];
    const clickHandler = () => {
      tourHandler?.();
    };
    const profileHandle = () => {
      profileHandler?.();
    };
    
   
    
    return (
      <Header
        style={{
          alignItems: 'center',
          backgroundColor: colors.black,
          direction: i18n.dir(),
        }}
        className={classes.root}
      >
        <div className={classes.mobileLogo}>
          <img
            style={{ marginBottom: '-25px' }}
            src={template==='01'?Logo1:Logo2}
            alt={'autoDialer'}
          />
        </div>
        {hamburgerMenu}
        <div style={{ display: 'inline' }}>
          <Space>
            {themeSwitch && (
              <Switch
                ref={ref1}
                checked={!isLight}
                onChange={() => changeTheme()}
                checkedChildren="🔆"
                unCheckedChildren="🌙"
              />
            )}
            {languageSwitch && (
              <Switch
                ref={ref2}
                checked={!isPersian}
                onChange={() => changeLanguage()}
                checkedChildren="fa"
                unCheckedChildren="en"
              />
            )}
            {
              <Select defaultValue={i18n.t('themeColor')} onChange={
                (e)=>{
                  e==="1" ? changeTemplate('01') : changeTemplate('02')
              }}>
                <option value={"0"} label={"0"}>{i18n.t("orange")}</option>
                <option value={"1"} label={"1"}>{i18n.t("purple")}</option>
              </Select>
            }
            {profileBtn && (
              <ProfileButton
                profileClick={profileHandle}
                changePasswordClick={changePasswordHandler}
              />
            )}
          </Space>
        </div>
        {children}

        {tourBtn && (
          <Button danger={true} type="primary" onClick={clickHandler}>
            {i18n.t('pageTutorial')}
          </Button>
        )}

        <Tour
          open={open}
          onClose={() => setOpen(false)}
          steps={steps}
          indicatorsRender={(current, total) => (
            <span>
              {current + 1} / {total}
            </span>
          )}
        />
      </Header>
    );
  }
);

export { MyHeader };
